/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import { useState } from 'react';
// @mui
import { MenuItem, IconButton } from '@mui/material';
// components
import Iconify from '../../../../components/Iconify';
import MenuPopover from '../../../../components/MenuPopover';

// ----------------------------------------------------------------------

Payment.propTypes = {
  onSuccess: PropTypes.func,
  onFail: PropTypes.func,
  plan_status: PropTypes.any,
};

export default function Payment({ onSuccess,onFail, plan_status }) {
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const ICON = {
    mr: 2,
    width: 20,
    height: 20,
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        <Iconify icon={'eva:more-vertical-fill'} width={20} height={20} />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        arrow="right-top"
        sx={{
          mt: -1,
          width: 160,
          '& .MuiMenuItem-root': { px: 1, typography: 'body2', borderRadius: 0.75 },
        }}
      >
        {/* when process */}
         {plan_status === 0 && <><MenuItem onClick={onSuccess} sx={{ color: 'success.main' }}>
                  <Iconify icon={'emojione:white-heavy-check-mark'} sx={{ ...ICON }} />
                 Approve 
              </MenuItem>
              <MenuItem onClick={onFail} sx={{ color: 'warning.main' }}>
                  <Iconify icon={'emojione:cross-mark-button'} sx={{ ...ICON }} />
               Fail
              </MenuItem></>}

         {/* when success */}
        {plan_status === 1 && <><MenuItem onClick={onFail} sx={{ color: 'error.main' }}>
                  <Iconify icon={'emojione:cross-mark-button'} sx={{ ...ICON }} />
                 Fail
              </MenuItem>
             </>}

{/* when transaction on fail */}
              {plan_status === 2 && <><MenuItem onClick={onSuccess} sx={{ color: 'success.main' }}>
                  <Iconify icon={'emojione:white-heavy-check-mark'} sx={{ ...ICON }} />
                 Approve
              </MenuItem>
             </>}
             
      </MenuPopover>
    </>
  );
}
